import styled from 'styled-components';

import { NewStyleColor } from '../../utils/styles-constants';
import { hexToRgba, spin } from '../../utils/style';

export const HEADER_HEIGHT = 74;
export const PAGE_TITLE_HEIGHT = 40;
export const PAGE_PADDING = 27;

interface LoaderProps {
	isCombo?: boolean;
}

interface PageWrapperProps {
	isMobileApp: boolean;
}

const editorScrollStyles = `
	&::-webkit-scrollbar {
		width: 16px;
	}

	&::-webkit-scrollbar-track {
		background-color: ${hexToRgba(NewStyleColor.Black, 20)};
	}

	&::-webkit-scrollbar-thumb {
		background-color: ${hexToRgba(NewStyleColor.White, 20)};
	}

	&::-webkit-scrollbar-corner {
		background-color: ${hexToRgba(NewStyleColor.Black, 20)};
	}
`;

const EditorContainer = styled('div')`
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
`;

const EditorWrapper = styled('div')`
	position: absolute;
	top: ${HEADER_HEIGHT}px;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	background-color: ${NewStyleColor.Grey900};
`;

const ContentWrapper = styled('div')`
	flex: 1 1 auto;
	display: flex;
	flex-direction: column;
	overflow: hidden;
`;

const ContentInner = styled('div')`
	flex: 1 1 auto;
	display: flex;
	overflow-x: hidden;
	overflow-y: auto;
`;

const PageWrapper = styled('div')`
	flex: 1 1 auto;
	display: flex;
	flex-direction: column;
	overflow: auto;

	${(props: PageWrapperProps) => !props.isMobileApp && editorScrollStyles}
`;

const Loader = styled('div')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${hexToRgba(NewStyleColor.Black, 75)};
	font-weight: bold;
	font-size: 21px;
	color: ${NewStyleColor.White};

	${(props: LoaderProps) => props.isCombo && 'z-index: 10;'}

	svg {
		height: 35px;
		width: 35px;
		animation: ${spin};
		margin-right: 20px;
	}
`;

export {
	EditorContainer,
	EditorWrapper,
	ContentWrapper,
	ContentInner,
	PageWrapper,
	Loader,
	editorScrollStyles,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/styles.ts